module.exports = __webpack_public_path__ + "img/[委屈].f51fc7e8.svg";